const backendUrl = `https://backend-feature-mabf5b354a-uc.a.run.app/api/`;
//const backendUrl = `https://df73-2800-150-109-1ed4-948-7991-59b7-c6fe.sa.ngrok.io/api`;

/**
 * Frontend Url.
 */
const frontendUrl = {
  host: 'staging.stemwaste.cl', // stem-waste-office-staging.web.app
  protocol: 'https',
};

/**
 * Tenant Mode
 * multi: Allow new users to create new tenants.
 * multi-with-subdomain: Same as multi, but enable access to the tenant via subdomain.
 * single: One tenant, the first user to register will be the admin.
 */
const tenantMode = 'multi';

/**
 * Plan payments configuration.
 */
const isPlanEnabled = false;
const stripePublishableKey = '';

/**
 * Google OAuth configuration.
 */
const googleClientId = '140175535522-i54quujp3hccqu4m4k3u61tpdpkgo3ml.apps.googleusercontent.com';

export default {
  frontendUrl,
  backendUrl,
  tenantMode,
  isPlanEnabled,
  stripePublishableKey,
  googleClientId,
};
